/* unplugin-vue-components disabled */import __unplugin_components_1 from 'D:/hjj/bio_link_pc/src/components/work_bench/CancelDialog.vue';
import __unplugin_components_0 from 'D:/hjj/bio_link_pc/src/components/BaseButton.vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, isRef as _isRef, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export default {
  __name: 'approval-cancel',
  props: ["origin_id", "approval_flow_id"],
  emits: ["success"],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var props = __props;
    var emit = __emit;
    var cancelDialogVisible = ref(false);
    var cancelParams = ref({});
    var handleCancelClick = () => {
      console.log("props--->", props);
      cancelParams.value = {
        origin_id: props.origin_id,
        approval_flow_id: props.approval_flow_id
      };
      cancelDialogVisible.value = true;
    };
    var handleCancelSuccess = () => {
      emit("success", "cancel");
    };
    return (_ctx, _cache) => {
      var _component_BaseButton = __unplugin_components_0;
      var _component_CancelDialog = __unplugin_components_1;
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_BaseButton, {
        onClick: handleCancelClick,
        text: "撤销",
        type: "revoke",
        style: {
          "margin-right": "10px"
        }
      }), _createVNode(_component_CancelDialog, {
        modelValue: _unref(cancelDialogVisible),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(cancelDialogVisible) ? cancelDialogVisible.value = $event : null),
        message: "确认要撤销此单据吗?",
        "confirm-type": "danger",
        onSuccess: handleCancelSuccess,
        "cancel-params": _unref(cancelParams)
      }, null, 8, ["modelValue", "cancel-params"])], 64);
    };
  }
};